// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2wYqN","title":"Images45_title__1UuWe","images":"Images45_images__3H9_L"};